import { useQuery } from "react-query"
import MessageService from "~services/MessageService"

const useMessages = (options?) => {
  return useQuery("messages", () => MessageService.getMessages(options), {
    enabled: false,
  })
}

export default useMessages
